import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Badge, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useRestaurantData } from '../../provider/RestaurantDataContext';
import { useCardContent } from '../../provider/CardContentContext';
import { useSnackbarProps } from '../../provider/SnackbarContext';

export default function CartComponent() {
  const { itemsInCart } = useCardContent();
  const { restaurantData } = useRestaurantData();
  const { showSnackbar } = useSnackbarProps();
  const versionCode = process.env.REACT_APP_VERSION;
  const buildDate = process.env.REACT_APP_BUILD_DATE;

  const handleClick = (e: { detail: any; }) => {
    switch (e.detail) {
      case 1:
        break;
      case 5:
        showSnackbar({ snackbarText: `Version-Code: ${versionCode}\nBuild-Date: ${buildDate}\nQR-Menu by AT-Corporation` });
        break;
      case 10:
        showSnackbar({ snackbarText: "Hello there, Sara will always be numero uno, lol" });
        break;
    }
  };

  return (
    <IconButton component={RouterLink} to={`/qr-menu/${restaurantData.id}/cart`} sx={{ color: 'white' }} size='small'>
      <Badge badgeContent={itemsInCart} color='secondary' max={9}>
        <ShoppingBasketIcon sx={{ fontSize: '2rem' }} onClick={handleClick} />
      </Badge>
    </IconButton>
  );
}